<template>
  <review-template :type="type"/>
</template>
<script>
import ReviewTemplate from '@/views/outbound/review_template/ReviewTemplate.vue'

export default {
  components: { ReviewTemplate },
  data() {
    return {
      loading: false,
      type: 'refundable'
    }
  }
}
</script>